export default "__VITE_ASSET__iLOn2C7k__"